import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { ActivatedRoute, Router } from "@angular/router";
import { isNullOrUndefined } from "util";
import { Client } from "../../models/client";
import { ScrollService } from "../../providers/scroll.service";
import { CustomPageData } from '../../models/customPageData';
import { NavigationItem } from '../../models/navigationItem';
import { DragulaService } from 'ng2-dragula';
import { environment } from '../../../environments/environment';
import { AboutRow } from '../../models/aboutRow';
var AWS = require('aws-sdk');
AWS.config.update(environment.aws);
var sqs = new AWS.SQS();

@Component({
  selector: 'app-edit-custom-page',
  templateUrl: './edit-custom-page.component.html',
  styleUrls: ['./edit-custom-page.component.css']
})
export class EditCustomPageComponent implements OnInit, AfterViewInit, OnDestroy {
  key: string;
  clientData: Client;
  pageData: CustomPageData = { html: '' };
  dropdowns: { name: string, key: string }[];
  locations: { name: string, key: string }[];
  currentDropdownKey: string;
  editName = false;
  updated = true;
  showPreview = false;
  previewButtonText = 'Preview';
  newOrder;
  rowLayoutOptions = [
    { label: 'Image/Video Left', value: 'imageLeft' },
    { label: 'Image/Video Right', value: 'imageRight' },
    { label: 'Stacked Image/Video Top', value: 'stackedImageTop' },
    { label: 'Stacked Image/Video Bottom', value: 'stackedImageBottom' },
    { label: 'Image/Video Only', value: 'imageOnly' },
    { label: 'HTML Only', value: 'htmlOnly' },
  ];

  // froala stuff
  options = {
    key: environment.froalaKey,
    charCounterCount: true,
    fontSizeDefaultSelection: '14',
    heightMin: 500,
    htmlExecuteScripts: false,
    htmlRemoveTags: ['style'],
    htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap', 'onclick'],
    events: {
      'froalaEditor.blur': function (e, editor) {
        document.getElementById('hacky-save-button-because-froala').click();
      }
    },
    pasteDeniedAttrs: [],
    toolbarSticky: true,
    toolbarStickyOffset: 100,
    htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'script', 'style']
  };
  initControls: any;
  deleteAll: any;
  setHtml: any;
  getHtml: any;
  cleanHtml: any;
  codeViewToggle: any;

  constructor(
    private afService: FirebaseService,
    private route: ActivatedRoute,
    private scroll: ScrollService,
    private router: Router,
    private dragulaService: DragulaService,
  ) {
    this.dragulaService.setOptions('dropdown-bag', { revertOnSpill: true });
  }

  async ngOnInit() {
    this.key = this.route.snapshot.params['key'];
    // get client info
    this.clientData = await this._getClientInfo();
    this.dropdowns = [];
    let flag = false;
    for (let key in this.clientData.navigation) {
      if (this.clientData.navigation[key].isDropDown) {
        if (this.clientData.navigation[key].name === 'No Dropdown') {
          flag = true;
        }
        this.dropdowns.push({ name: this.clientData.navigation[key].name, key: key });
      }
    }
    if (!flag) {
      this.addNoDropdown();
    }

    // get location keys
    this.locations = [];
    for (let location of await this._getLocations()) {
      this.locations.push({ name: location.name, key: location.$key });
    }

    // get page data
    this.pageData = await this._getCustomPage();
    console.log(this.pageData)
    this.pageData.key = this.pageData.$key;
    this.currentDropdownKey = this.pageData.dropdownKey;
    if (isNullOrUndefined(this.pageData.locationKeys)) {
      this.pageData.locationKeys = [];
    }

    this.dragulaService.dropModel.subscribe(domStuff => this.saveOrder());
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
    // initialize froala
    // this.initControls.initialize();
  }

  ngOnDestroy() {
    this.dragulaService.destroy('dropdown-bag');
  }

  /**
   * display page url or urls under page title
   */
  printPageUrls() {
    if (!isNullOrUndefined(this.clientData) && this.currentDropdownKey) {
      let url = `${ this.clientData.siteUrl }/`;
      if (this.pageData.isLandingPage) {
        url += 'landing/';
        if (this.pageData.isLocationSpecific) {
          url += 'location-key/';
        }
      }
      else {
        if (this.pageData.isLocationSpecific) {
          url += 'location-key/';
        }
        url += `${ this.clientData.navigation[this.currentDropdownKey].canonical }/`;
      }
      url += `${ this.pageData.route }/`;

      if (this.pageData.isLocationSpecific) {
        let rtn = '';
        for (let locationKey of this.pageData.locationKeys) {
          rtn += `<p class="lt-grey">${ url.replace('location-key', locationKey) }</p>`;
        }
        return rtn;
      }
      else {
        return `<p class="lt-grey">${ url }</p>`;
      }
    }
  }

  /**
   * save the page...pretty obvious
   */
  savePage() {
    this.updated = false;
    this.pageData.route = this.pageData.name.replace(/\W+/g, '-').toLowerCase();
    this.pageData.updatedOn = new Date().toString();
    this.afService.updateCustomPage(this.pageData, this.key).then(() => {
      // update reference in the dropdown, if needed
      const index = this.clientData.navigation[this.currentDropdownKey].children.findIndex(i => i.key === this.pageData.key);
      if (index > -1) {
        this.clientData.navigation[this.currentDropdownKey].children[index] = this.pageData;
        this.updateNavItem(this.currentDropdownKey, this.clientData.navigation[this.currentDropdownKey])
          .then(() => this.updated = true);
      }
      else {
        this.updated = true;
      }
    });
  }

  /**
   * duplicate the page...pretty obvious
   */
  duplicatePage() {
    let newPage: CustomPageData = JSON.parse(JSON.stringify(this.pageData));
    newPage.createdOn = new Date().toString();
    newPage.dropdownKey = null;
    newPage.key = null;
    newPage.name = newPage.name + ' Duplicate';
    this.afService.saveCustomPage(newPage, this.key).then(data => {
      newPage.key = data.key;
      this.afService.updateCustomPage(newPage, this.key).then(() => {
        this.afService.openSnackBar('Duplicated successfully.');
      });
    });
  }

  togglePreviewPage() {
    this.showPreview = !this.showPreview;
    if (this.showPreview) {
      this.previewButtonText = 'Close Preview';
    }
    else {
      this.previewButtonText = 'Preview';
    }
  }

  /**
   * @param event
   *
   * remove from old dropdown and add to new one
   */
  changeDropdown(event) {
    this.updated = false;
    // remove from old dropdown
    if (!isNullOrUndefined(this.currentDropdownKey) && this.currentDropdownKey !== '' && this.currentDropdownKey !== this.pageData.dropdownKey) {
      const index = this.clientData.navigation[this.currentDropdownKey].children.findIndex(i => i.key === this.pageData.key);
      if (index > -1) {
        this.clientData.navigation[this.currentDropdownKey].children.splice(index, 1);
        this.updateNavItem(this.currentDropdownKey, this.clientData.navigation[this.currentDropdownKey]);
      }
    }
    // append to chosen dropdown child array
    this.currentDropdownKey = this.pageData.dropdownKey;
    if (isNullOrUndefined(this.clientData.navigation[this.currentDropdownKey].children)) {
      this.clientData.navigation[this.currentDropdownKey].children = [];
    }
    this.clientData.navigation[this.currentDropdownKey].children.push(this.pageData);
    this.updateNavItem(this.currentDropdownKey, this.clientData.navigation[this.currentDropdownKey])
      .then(() => this.savePage());
  }

  updateNavItem(navItemKey, navItem) {
    return this.afService.updateNavItemWithSeparateKey(this.clientData, navItemKey, navItem);
  }

  addOrRemoveLandingPageFromDropdown() {
    this.updated = false;
    if (this.pageData.isLandingPage && this.pageData.dropdownKey) {
      const index = this.clientData.navigation[this.pageData.dropdownKey].children.findIndex(i => i.key === this.pageData.key);
      if (index > -1) {
        this.clientData.navigation[this.pageData.dropdownKey].children.splice(index, 1);
        this.updateNavItem(this.pageData.dropdownKey, this.clientData.navigation[this.pageData.dropdownKey])
          .then(() => this.savePage());
      }
    }
    else if (!this.pageData.isLandingPage && this.pageData.dropdownKey) {
      this.currentDropdownKey = this.pageData.dropdownKey;
      if (isNullOrUndefined(this.clientData.navigation[this.currentDropdownKey].children)) {
        this.clientData.navigation[this.currentDropdownKey].children = [];
      }
      this.clientData.navigation[this.currentDropdownKey].children.push(this.pageData);
      this.updateNavItem(this.currentDropdownKey, this.clientData.navigation[this.currentDropdownKey])
        .then(() => this.savePage());
    }
  }

  addNoDropdown() {
    console.log('hey')
    let navItem: NavigationItem = {
      name: 'No Dropdown',
      route: null,
      isDropDown: true,
      canonical: 'storage',
      external: false,
      topLevel: false,
      children: []
    };
    this.afService.updateNavItemWithSeparateKey(this.clientData, 'noDropdown', navItem);
  }

  /**
   * save the order of the dropdown links
   */
  saveOrder() {
    this.updated = false;
    this.updateNavItem(this.currentDropdownKey, this.clientData.navigation[this.currentDropdownKey])
      .then(() => this.updated = true);
  }

  toggleLocation(locationKey) {
    this.updated = false;
    if (isNullOrUndefined(this.pageData.locationKeys)) {
      this.pageData.locationKeys = [];
    }
    const i = this.pageData.locationKeys.indexOf(locationKey);
    if (i === -1) {
      this.pageData.locationKeys.push(locationKey);
    }
    else {
      this.pageData.locationKeys.splice(i, 1);
    }
    this.savePage();
  }

  getCheckboxValue(locationKey) {
    return this.pageData.locationKeys.indexOf(locationKey) > -1;
  }

  addRow() {
    if (!this.pageData.rows) {
      this.pageData.rows = [];
    }
    this.pageData.rows.push(new AboutRow());
    this.savePage();
  }

  moveRow(dir, index) {
    if (dir === 'up') {
      const swapIndex = index - 1;
      [this.pageData.rows[swapIndex], this.pageData.rows[index]] = [this.pageData.rows[index], this.pageData.rows[swapIndex]];
    }
    else {
      const swapIndex = index + 1;
      [this.pageData.rows[index], this.pageData.rows[swapIndex]] = [this.pageData.rows[swapIndex], this.pageData.rows[index]];
    }
    this.savePage();
  }

  removeRow(index) {
    if (confirm('Are you sure?')) {
      this.pageData.rows.splice(index, 1);
      this.savePage();
    }
  }

  updateSettingsOnServer() {
    var params = {
      MessageBody: environment.env,
      QueueUrl: 'https://sqs.us-east-1.amazonaws.com/729153069069/update-settings-to-client',
      DelaySeconds: 0,
      MessageAttributes: {
        clientCode: {
          DataType: 'String',
          StringValue: this.clientData.code
        },
      }
    };
    sqs.sendMessage(params, (err, data) => {
      if (err) {
        console.log(err, err.stack);
        this.afService.openSnackBar('ERROR');
      }
      else {
        console.log(data);
        this.afService.openSnackBar('Update settings added to SQS queue.');
      }
    });
  }

  // froala
  initialize(initControls) {
    this.initControls = initControls;
    this.deleteAll = function () {
      this.initControls.getEditor()('html.set', '');
    };
    this.setHtml = function (pageHtml) {
      this.initControls.getEditor()('html.set', pageHtml);
    };
    this.getHtml = function (pageHtml) {
      return this.initControls.getEditor()('html.get');
    };
    this.codeViewToggle = function () {
      return this.initControls.getEditor()('codeView.toggle');
    };
    this.cleanHtml = function (pageHtml) {
      return this.initControls.getEditor()('clean.html', pageHtml);
    };
  }

  goBack() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  private _getClientInfo(): Promise<Client> {
    return new Promise((resolve, reject) => {
      this.afService.getClientInfo(this.key)
        .subscribe((data: Client) => resolve(data), error => reject(error));
    });
  }

  private _getLocations(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.afService.getLocationsByKey(this.key)
        .subscribe((data) => resolve(data), error => reject(error));
    });
  }

  private _getCustomPage(): Promise<CustomPageData> {
    return new Promise((resolve, reject) => {
      this.afService.getCustomPage(this.key, this.route.snapshot.params['pageKey'])
        .subscribe((data) => resolve(data), error => reject(error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/edit-custom-page/edit-custom-page.component.ts